import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Grid from 'components/Grid'
import Icon from 'components/Icon'

import ContentfulDocument from '../ContentfulDocument/ContentfulDocument'

import classes from './LegalPageFaq.module.scss'

export default ({ question, answer, expanded = false, onToggle }) => {
  return (
    <div
      className={`${classes.entry} ${expanded ? classes.entryExpanded : ''}`}
      onClick={() => onToggle(!expanded)}
      role="presentation"
    >
      <div className={classes.question}>
        <Grid container spacing={3}>
          <Grid item lg={11} md={11} xs={10} sm={11}>
            {question}
          </Grid>
          <Grid item lg={1} md={1} xs={2} sm={1}>
            <IconButton component="div" className={clsx(classes.icon, expanded && classes.expanded)}>
              <Icon icon="chevron-down" data-testid="chevron-down" />
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <div
        className={`${classes.answer} ${expanded ? classes.answerExpanded : ''}`}
        onClick={e => e.stopPropagation()}
        role="presentation"
      >
        <ContentfulDocument content={answer.json} />
      </div>
    </div>
  )
}
